import React, { useState } from "react";
import logo from "../../assets/img/youl-systems-logo.svg";

export default function Sidebar() {
  const sideBarTabs = ["All", "I3D web", "Webgl", "홍보영상", "기타"];

  const [activeTab, setActiveTab] = useState("All");
  return (
    <div className="bg-[#363C55] flex flex-col flex-1">
      {/* logo  */}
      <div className="h-[141px] flex items-center justify-center">
        <img src={logo} alt="" className="max-w-[110px] w-full" />
      </div>
      {/* tab  */}
      <div className="flex flex-col gap-2.5">
        {sideBarTabs.map((tab, idx) => (
          <button
            key={idx}
            onClick={() => setActiveTab(tab)}
            className={`px-10 py-1.5 text-left border-r-[3px] text-[14px] font-normal  hover:bg-[#E96F0C1A] ${
              activeTab === tab
                ? "border-[#E96F0C] bg-gradient-to-l from-[#E96F0C66] to-[#E96F0C1A] text-[#E96F0C]"
                : "text-[#8E98C7]  border-transparent"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
}
